import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SectionWrapper = styled.div`
  padding: ${Spacing.S24};
`

export const BookingLineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${Spacing.S12} 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${Color.Grey100};
  }
`

export const DetailLineWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S32};
  justify-content: space-between;
  padding: ${Spacing.S8} 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${Color.Grey100};
  }
`
